export default {"src":"/_next/static/media/fauna.39618846.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};